import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type Dashboard from './dashboard';
import type Report from './reports';

interface SizeConfig {
  size?: 'small' | 'medium' | 'large';
  [key: string]: unknown;
}

export default class DashboardReport extends Model {
  @attr declare position: number;
  @attr declare sizeConfig: SizeConfig;

  @belongsTo('dashboard', { async: false, inverse: 'dashboardReports' })
  declare dashboard: Dashboard;

  @belongsTo('report', { async: false, inverse: null })
  declare report: Report;

  get size() {
    return this.sizeConfig?.size ?? 'medium';
  }

  [Type] = 'dashboard-report' as const;
}

export type { SizeConfig };
